import { ElementRef, Injectable } from '@angular/core';
import { Subject, map, scan, shareReplay } from 'rxjs';
import { maxSizeOfFiles } from 'src/globals';

@Injectable({
    providedIn: 'root',
})
export class AttachmentSizeService {
    private trackFileSubject = new Subject<{ owner: ElementRef<HTMLInputElement>; files: File[] }>();
    public readonly allUploadedFilesSizeExceeded$ = this.trackFileSubject.pipe(
        scan((currentTracks, newTrack) => {
            return [...currentTracks.filter((track) => track.owner !== newTrack.owner), newTrack];
        }, new Array<{ owner: ElementRef<HTMLInputElement>; files: File[] }>()),
        map((currentTracks) => {
            const summedSize = currentTracks.reduce((sum, track) => {
                const trackFilesSummedSize = track.files.reduce((sum, file) => {
                    return sum + file.size;
                }, 0);

                return sum + trackFilesSummedSize;
            }, 0);
            return summedSize > maxSizeOfFiles;
        }),
        shareReplay(1)
    );
    trackFiles(track: { owner: ElementRef<HTMLInputElement>; files: File[] }) {
        this.trackFileSubject.next(track);
    }
}
